export const APP_CONFIG = {
  SOCKET_URL: 'https://your-backend.com',
  AGORA_APP_ID: 'b0fc8da1f9304a728076ff96220d3ebb'
};